import type { FC } from 'react';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import TrendingSection from './components/TrendingSection';
import NewsletterSection from './components/NewsletterSection';
import FAQSection from './components/FAQSection';

const HomePage: FC = () => {
  const pageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'ASMR基佬中心 | 专属ASMR内容聚合平台',
    description: 'ASMR基佬中心是专为ASMR爱好者打造的内容聚合社区，汇聚海量ASMR音频视频资源，提供放松助眠、情感陪伴类ASMR内容。',
    url: 'https://jybmfiu.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: 'ASMR基佬中心',
      url: 'https://jybmfiu.cn',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(pageJsonLd)}</script>
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <TrendingSection />
        <NewsletterSection />
        <FAQSection />
      </main>
    </>
  );
};

export default HomePage;